import React from 'react'

import { datadogRum } from '@datadog/browser-rum'
import {
  AlignItems,
  AlignSelf,
  Body2,
  Box,
  Color,
  Display,
  FontWeight,
  Icon,
  IconVariant,
  Visible,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'
import { browserHistory } from 'react-router'
import { useLocation } from 'react-use'

const onSpaceOrEnter =
  (callback: (event: React.KeyboardEvent) => void) => (event: React.KeyboardEvent) => {
    if (event.code === 'Space' || event.code === 'Enter') {
      event.preventDefault()
      callback(event)
    }
  }

const LinkButton = withCitrusTheme(Box, () => ({
  cursor: 'pointer',
}))

export const BackToBrowse = () => {
  const { pathname } = useLocation()

  const handleClick = () => {
    datadogRum.addAction('back_to_browse_button_clicked')
    browserHistory.push({ pathname, search: '?collection=browse' })
  }

  return (
    <Box alignSelf={AlignSelf.Start}>
      <Visible display={[Display.None, Display.None, Display.Block]}>
        <LinkButton
          aria-label="Back to Browse"
          data-testid="back-to-browse-button"
          display={Display.Flex}
          alignItems={AlignItems.Center}
          onClick={handleClick}
          onKeyDown={onSpaceOrEnter(handleClick)}
          role="button"
          tabIndex={0}
        >
          <Icon name="arrow_back" variant={IconVariant.Actionable} />
          <Body2 color={Color.Secondary_400} fontWeight={FontWeight.Bold}>
            Back to Browse
          </Body2>
        </LinkButton>
      </Visible>
    </Box>
  )
}
